import React from "react";
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps";
import { compose, lifecycle, withStateHandlers } from "recompose";
import { Marker } from "react-google-maps";

const ContactMap = compose(
  withScriptjs,
  withGoogleMap,
  withStateHandlers(
    () => ({
      isOpen: false,
    }),
    {
      onToggleOpen: ({ isOpen }) => () => ({
        isOpen: !isOpen,
      }),
    }
  ),
  lifecycle({
    componentDidMount() {
      const google = window.google;
      let bounds = new google.maps.LatLngBounds();
      const MARKERS = (
        <Marker
          key={this.props.stop.lat}
          position={{
            lat: parseFloat(this.props.stop.lat),
            lng: parseFloat(this.props.stop.lng),
          }}
          icon="/images/powered.png"
        />
      );

      let latlng = {
        lat: parseFloat(this.props.stop.lat),
        lng: parseFloat(this.props.stop.lng),
      };
      bounds.extend(latlng);

      this.setState({
        markers: MARKERS,
        center: bounds.getCenter(),
      });
    },
  })
)((props) => (
  <GoogleMap
    defaultZoom={15}
    center={props.center}
    defaultOptions={{
      styles: [
        {
          featureType: "all",
          elementType: "labels.text.fill",
          stylers: [
            { saturation: 36 },
            { color: "#333333" },
            { lightness: 40 },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.text.stroke",
          stylers: [
            { visibility: "on" },
            { color: "#ffffff" },
            { lightness: 16 },
          ],
        },
        {
          featureType: "all",
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "administrative",
          elementType: "geometry.fill",
          stylers: [{ color: "#fefefe" }, { lightness: 20 }],
        },
        {
          featureType: "administrative",
          elementType: "geometry.stroke",
          stylers: [{ color: "#fefefe" }, { lightness: 17 }, { weight: 1.2 }],
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [{ color: "#f6f6f6" }, { lightness: "-11" }],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }, { lightness: 21 }],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#dedede" }, { lightness: 21 }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [{ color: "#ffffff" }, { lightness: 17 }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [{ color: "#ffffff" }, { lightness: 29 }, { weight: 0.2 }],
        },
        {
          featureType: "road.arterial",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-10" }],
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }, { lightness: "-12" }],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [{ visibility: "off" }],
        },
        {
          featureType: "transit",
          elementType: "geometry",
          stylers: [{ color: "#693b1d" }, { lightness: 19 }],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            { color: "#e9e9e9" },
            { lightness: "-47" },
            { saturation: "0" },
          ],
        },
      ],
    }}
  >
    {props.markers}
  </GoogleMap>
));

export default ContactMap;



// WEBPACK FOOTER //
// ./src/components/Pages/Contact/ContactMap.js